import { Box, Container, Typography } from "@mui/material";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import CurrencyBitcoinOutlinedIcon from "@mui/icons-material/CurrencyBitcoinOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";

const GOLD = "#D97706";

const INDUSTRIES = [
  { Icon: DiamondOutlinedIcon,         accent: GOLD,      title: "Precious Metals & Stones", desc: "Gold dealers, jewellers, and gem traders under UAE MOE and CBUAE mandates." },
  { Icon: ApartmentOutlinedIcon,       accent: "#2563EB", title: "Real Estate",              desc: "Brokers, developers, and property managers subject to RERA and FIU obligations." },
  { Icon: CurrencyBitcoinOutlinedIcon, accent: "#EA580C", title: "Virtual Assets (VASPs)",   desc: "Crypto exchanges and VASPs fulfilling VARA and FATF Travel Rule requirements." },
  { Icon: AccountBalanceOutlinedIcon,  accent: "#16A34A", title: "Financial Institutions",   desc: "Banks, exchange houses, insurance firms, and money service businesses." },
  { Icon: GavelOutlinedIcon,           accent: "#7C3AED", title: "Legal & Notary",           desc: "Law firms and notaries handling client funds or asset management." },
  { Icon: CalculateOutlinedIcon,       accent: "#DC2626", title: "Accountants & Auditors",   desc: "Chartered accountants providing designated services to high-risk clients." },
  { Icon: DirectionsCarOutlinedIcon,   accent: "#0891B2", title: "Luxury Goods & Vehicles",  desc: "High-value dealers in cars, art, antiques, and collectables." },
  { Icon: StoreOutlinedIcon,           accent: "#059669", title: "Other DNFBPs",             desc: "Any DNFBP under FATF Recommendations 22 & 23 AML-CFT obligations." },
];

export default function IndustriesSection() {
  return (
    <Box
      id="industries"
      sx={{ background: "#fff", py: { xs: 10, md: 16 }, borderTop: "1px solid #E2E8F0" }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography sx={{ fontSize: 11, fontWeight: 600, color: GOLD, letterSpacing: "3px", textTransform: "uppercase", mb: 2, fontFamily: "IBM Plex Sans, sans-serif" }}>
            Industries
          </Typography>
          <Typography component="h2" className="font-display" sx={{ fontSize: { xs: 28, md: 46 }, fontWeight: 700, color: "#0F172A", letterSpacing: "-1.5px", lineHeight: 1.1, mb: 2.5 }}>
            Built for your sector
          </Typography>
          <Typography sx={{ fontSize: 17, color: "#64748B", maxWidth: 500, mx: "auto", lineHeight: 1.8, fontFamily: "IBM Plex Sans, sans-serif" }}>
            AMLDiligence is purpose-built for regulated non-financial businesses across the UAE and the wider MENA region.
          </Typography>
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" }, gap: 2 }}>
          {INDUSTRIES.map(ind => (
            <Box key={ind.title} sx={{
              background: "#fff",
              border: "1px solid #E2E8F0",
              borderRadius: "14px",
              p: 3.5,
              boxShadow: "0 1px 4px rgba(15,23,42,.04)",
              transition: "all .25s cubic-bezier(.4,0,.2,1)",
              position: "relative", overflow: "hidden",
              "&:hover": {
                borderColor: ind.accent,
                transform: "translateY(-4px)",
                boxShadow: `0 16px 40px ${ind.accent}14`,
              },
              "&::after": {
                content: '""', position: "absolute",
                bottom: 0, left: 0, right: 0, height: "3px",
                background: ind.accent,
                transform: "scaleX(0)", transformOrigin: "left",
                transition: "transform .25s",
              },
              "&:hover::after": { transform: "scaleX(1)" },
            }}>
              <Box sx={{
                width: 46, height: 46, borderRadius: "11px",
                background: `${ind.accent}10`, border: `1px solid ${ind.accent}20`,
                display: "flex", alignItems: "center", justifyContent: "center", mb: 2.5,
              }}>
                <ind.Icon sx={{ fontSize: 22, color: ind.accent }} />
              </Box>
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#0F172A", mb: .75, lineHeight: 1.3, fontFamily: "IBM Plex Sans, sans-serif" }}>
                {ind.title}
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#64748B", lineHeight: 1.75, fontFamily: "IBM Plex Sans, sans-serif" }}>
                {ind.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
